import { Link, useLocation } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import { CollapsibleGroup } from './CollapsibleGroup';
import type { IMenuLinksGroupProps } from './IMenuLinksGroupProps';
import { menuLinkActive } from './menuLinkActive';

/**
 * Розгортна група посилань меню («Налаштування», «Проєктування»; прототип v4 ngDef / mdOpen): типово згорнута й на своїх сторінках —
 * відкриває її лише вибір користувача (пам'ятається, доки відкрито модуль); група з `openOnPage` («Проєктування») на своїх сторінках
 * розгорнута завжди. Активний пункт — за маршрутом і параметрами посилання (menuLinkActive: довідник на «Записах і формах» з ?focus=);
 * лічильник (кількість у визначенні) — праворуч; довідники модуля — приглушені.
 */
export function MenuLinksGroup({ id, title, links, base, openState, openOnPage = false }: IMenuLinksGroupProps) {
  const { pathname, search } = useLocation();
  if (!links.length) return null;
  const isActive = (l: (typeof links)[number]) => l.active ?? menuLinkActive(l.to, pathname, search);
  const forced = openOnPage && (pathname === base || links.some(isActive));
  return (
    <CollapsibleGroup title={title} open={forced || openState.isOpen(id, false)} onToggle={() => openState.toggle(id, false)}>
      {links.map((l) => {
        const active = isActive(l);
        return (
          <Link key={l.key} className={cx('mnav__item', l.muted && 'is-muted', active && 'is-active')} to={l.to} aria-current={active ? 'page' : undefined}>
            <span className="mnav__label" title={l.label}>{l.label}</span>
            {l.count !== undefined && <span className="mnav__count">{l.count}</span>}
          </Link>
        );
      })}
    </CollapsibleGroup>
  );
}
